<template>
<div>
	<div v-if="isProductionCode" class="text-center">
    <div v-html="config.statCounterTrackingCode"></div>
  </div>
</div>
</template>

<script>
import { config } from '@/config'
import { isProductionCode } from '@/utils/utils'
export default {
  name: 'FooterApp',
  data () {
    return {
      config: config,
    }
  },
  computed: {
    isProductionCode: isProductionCode
  },
}
</script>


